import {Invoices} from '@/store/modules/invoices/types'
import {TransferItem} from '@/store/modules/transfer/types'

const findTransferItem = (list: Invoices[], transferItem: TransferItem) => {
  return list.find((invoiceItem) => (
    invoiceItem.amount === transferItem.transferAmount &&
    invoiceItem.clientBankAccount?.number === transferItem.inAccountNumber
  )) || {
    clientName: '',
    clientSummary: '',
    bizSummary: '',
  }
}

export {findTransferItem}
